/**
 * Theme System
 * 
 * Central export for all themes and theme utilities
 */

export * from './base';
export * from './brand-variants';

import { Theme, baseTheme } from './base';
import { brandVariants, BrandVariant } from './brand-variants';
import { hslToString } from '../tokens/colors';

/**
 * Get theme by name
 */
export const getTheme = (variant: BrandVariant | 'base' = 'base'): Theme => {
  if (variant === 'base') return baseTheme;
  return brandVariants[variant];
};

/**
 * Apply theme to CSS variables
 */
export const applyTheme = (
  theme: Theme,
  mode: 'light' | 'dark' = 'light'
): void => {
  const colors = theme[mode];
  const root = document.documentElement;

  Object.entries(colors).forEach(([key, value]) => {
    root.style.setProperty(`--${key}`, hslToString(value));
  });

  // Apply font families if defined
  if (theme.fontFamily) {
    Object.entries(theme.fontFamily).forEach(([key, value]) => {
      if (value) {
        root.style.setProperty(`--font-${key}`, value);
      }
    });
  }
};

/**
 * Get all available theme names
 */
export const getThemeNames = (): Array<BrandVariant | 'base'> => {
  return ['base', ...Object.keys(brandVariants)] as Array<BrandVariant | 'base'>;
};

/**
 * Statsig integration helper
 * This will be used when Statsig is implemented
 */
export interface ThemeExperiment {
  experimentKey: string;
  variants: {
    control: BrandVariant | 'base';
    treatment: BrandVariant | 'base';
  };
}

/**
 * Future: Get theme from Statsig experiment
 * For now, returns base theme
 */
export const getExperimentalTheme = (
  _experiment?: ThemeExperiment
): Theme => {
  // TODO: Integrate with Statsig
  // const variant = statsig.getExperiment(experiment.experimentKey);
  // return getTheme(variant);
  
  return baseTheme;
};
